import { render, staticRenderFns } from "./MenuMargins.vue?vue&type=template&id=7296aecb&scoped=true&"
import script from "./MenuMargins.vue?vue&type=script&lang=js&"
export * from "./MenuMargins.vue?vue&type=script&lang=js&"
import style0 from "./MenuMargins.vue?vue&type=style&index=0&id=7296aecb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7296aecb",
  null
  
)

export default component.exports